module.exports = __webpack_public_path__ + "img/Speed.0f7cc560.jpeg";